export default () => ({
  isLoaded: false,
  error: null,

  profile: null,
  signature: null,
});
